export default function filterReports() {
  const select = document.querySelector(".custom-select");
  if (!select) return;

  const selected = select.querySelector(".selected");
  const options = select.querySelectorAll(".options li");
  const reports = document.querySelectorAll(".download-report");
  const selectContainer = select.closest(".select-container");
  const optionsList = select.querySelector(".options");

  // Hide the filter dropdown when there is 0 or 1 option
  if (options.length <= 1) {
    selectContainer.style.display = "none";
  }

  // This will display reports for the chosen year
  const showReport = (year) => {
    reports.forEach((report) => {
      report.style.display = report.dataset.year === year ? "block" : "none";
    });
  };

  const toggleDropdown = (isOpen) => {
    if (isOpen) {
      select.classList.add("open");
      const dropdownHeight = optionsList.scrollHeight + 40;
      selectContainer.style.marginBottom = dropdownHeight + "px";
    } else {
      select.classList.remove("open");
      selectContainer.style.marginBottom = "0";
    }
  };

  let savedYear = localStorage.getItem("selectedYear") || selected.textContent;

  // check if saved year is still in the options
  let yearExists = false;

  options.forEach((opt) => {
    if (opt.dataset.value === savedYear) {
      yearExists = true;
    }
  });

  if (!yearExists) {
    localStorage.removeItem("selectedYear");
    savedYear = options[0]?.dataset.value;
  }

  if (savedYear) {
    selected.textContent = savedYear;
    showReport(savedYear);
    options.forEach((option) =>
      option.classList.toggle("active", option.dataset.value === savedYear),
    );
  }

  selected.addEventListener("click", (e) => {
    e.stopPropagation();
    toggleDropdown(!select.classList.contains("open"));
  });

  options.forEach((option) => {
    option.addEventListener("click", (e) => {
      e.stopPropagation();
      const year = option.dataset.value;

      selected.textContent = year;
      localStorage.setItem("selectedYear", year);
      showReport(year);

      options.forEach((yearOption) => yearOption.classList.remove("active"));
      option.classList.add("active");

      toggleDropdown(false);
    });
  });

  document.addEventListener("click", () => {
    toggleDropdown(false);
  });
}
